import { useEffect, useRef, useState } from "react";
import api from "../lib/api";

// Streams the rider's browser GPS to the backend every 10s while they have active deliveries.
export function useRiderGps(active) {
  const [state, setState] = useState("idle");
  const last = useRef(null);

  useEffect(() => {
    if (!active) { setState("idle"); return undefined; }
    if (!navigator.geolocation) { setState("unsupported"); return undefined; }
    const watchId = navigator.geolocation.watchPosition(
      (pos) => { last.current = { lat: pos.coords.latitude, lng: pos.coords.longitude }; setState("tracking"); },
      (err) => { console.error("GPS error:", err); setState(err.code === 1 ? "denied" : "error"); },
      { enableHighAccuracy: true, maximumAge: 5000, timeout: 20000 }
    );
    const send = () => {
      if (last.current) api.post("/rider/location", last.current).catch((e) => console.error("Location upload failed:", e));
    };
    const t = setInterval(send, 10000);
    const first = setTimeout(send, 1500);
    return () => { navigator.geolocation.clearWatch(watchId); clearInterval(t); clearTimeout(first); };
  }, [active]);

  return state;
}
